<template>
  <div class="recurring-signup">
    <div class="content" id="schedule">
      <h1>{{ $t('pages.recurring-signup.headline') }}</h1>

      <div class="schedule-call-container">
        <h2>{{ $t('pages.recurring-signup.headline-extra') }}</h2>
        <p><span class="highlight">{{ $t('pages.recurring-signup.text-highlighted') }}</span> {{ $t('pages.recurring-signup.text') }}</p>
        <RecurringDatetimePicker ref="picker" :hideTitle="true" />
        <p>{{ $t('pages.recurring-signup.cancel-text') }}</p>
      </div>
      <div class="confirm-call-container">
        <p
          :class="{ hidden: !error.isShown }"
          class="error">{{ error.text }}</p>
        <button
          v-on:click="submitRecurringSignup"
          :disabled="isLoading">
          <span v-if="!isLoading">{{ $t('pages.recurring-signup.signup-button') }}</span>
          <span v-if="isLoading" class="loading">Loading<span>.</span><span>.</span><span>.</span></span>
        </button>
        <p class="small">{{ $t('pages.recurring-signup.privacy-policy-text') }} <router-link :to="{ name: 'privacy' }">{{ $t('pages.recurring-signup.privacy-policy') }}</router-link> {{ $t('pages.recurring-signup.privacy-policy-text-between') }} <a href="https://www.twilio.com/legal/privacy">{{ $t('pages.recurring-signup.privacy-policy-twilio') }}</a>.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { resolveJSON } from '@/helperfunctions'
import RecurringDatetimePicker from '@/components/RecurringSignup/RecurringDatetimePicker'
import { DateTime } from 'luxon'

export default {
  name: 'recurring-signup',
  components: {
    RecurringDatetimePicker,
  },
  data () {
    return {
      isLoading: false,
      error: {
        isShown: false,
        text: '',
      }
    }
  },
  created () {
    this.checkData()
  },
  computed: {
    anyWeekday () {
      return this.$root.recurringPicker.weekday.Monday ||
        this.$root.recurringPicker.weekday.Tuesday ||
        this.$root.recurringPicker.weekday.Wednesday ||
        this.$root.recurringPicker.weekday.Thursday ||
        this.$root.recurringPicker.weekday.Friday
    }
  },
  methods: {
    checkData() {
      if (!this.$root.mep.id || !this.$root.phonenumber.digit ) {
        this.$router.push({ name: 'landing', hash: '#calling' })
      }
    },
    submitRecurringSignup() {
      this.error.text = ''
      this.error.isShown = false

      if(!this.anyWeekday) {
        this.error.text = this.$t('pages.recurring-signup.error-weekday')
        this.error.isShown = true
        return
      }

      if (!this.$root.phonenumber.digit) {
        this.error.text = this.$t('pages.recurring-signup.error-phonenumber')
        this.error.isShown = true
        return
      }

      this.isLoading = true

      fetch('/api/user', {
        method: 'POST',
        body: JSON.stringify({
          country: this.$root.country,
          language: this.$route.params.lang,
          phone_number: this.$root.phonenumber.digit,
          monday: this.$root.recurringPicker.weekday.Monday,
          tuesday: this.$root.recurringPicker.weekday.Tuesday,
          wednesday: this.$root.recurringPicker.weekday.Wednesday,
          thursday: this.$root.recurringPicker.weekday.Thursday,
          friday: this.$root.recurringPicker.weekday.Friday,
          time: this.$root.recurringPicker.time
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resolveJSON)
        .then(json => {
          if (!json.success) {
            if (!json.error) {
              throw Error(this.$t('components.phoneinput.error-nondescript'))
            }
            throw Error(json.error)
          }

          this.isLoading = false
          this.$router.push({ name: 'recurring-signup-confirmation' })
        })
        .catch(error => {
          this.error.text = error.message
          this.error.isShown = true
          this.isLoading = false
        })
    }
  }
}
</script>


<style lang=scss>
@import '@/assets/styles/_variable.scss';

.recurring-signup {
  display: flex;
  flex-direction: column;

  .content {
    min-height: 100vh;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 1em;

    h1 {
      font-size: 3em;
      line-height: 1em;
      margin: 0em;
    }
    p {
      margin: 0.2em 0;

      span.highlight {
        background-color: $dark-text-color;
        color: $main-bg;
        padding: 0 2px;
      }
    }

    .schedule-call-container {
      background-color: white;
      padding: 1em;
      margin-top: 1em;
      h2 {
        font-size: 1.5em;
        margin: 0 0 0.5em;
      }
    }

    .confirm-call-container {
      display: flex;
      flex-direction: column;
      margin-top: 1em;
    }
  }
}
</style>
